module.exports = __webpack_public_path__ + "static/media/lock-alt.9f442161.svg";